import { render, staticRenderFns } from "./AppendList.vue?vue&type=template&id=3f806ceb&"
import script from "./AppendList.vue?vue&type=script&lang=js&"
export * from "./AppendList.vue?vue&type=script&lang=js&"
import style0 from "./AppendList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/AppendList.vue
// module id = null
// module chunks = 